import { DeliveryClient } from './delivery-client';
export function createDeliveryClient(config) {
    return new DeliveryClient(config);
}
//# sourceMappingURL=delivery-client.factory.js.map